import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  category: string;
  cover: string;
  rating: number;
  status: string;
  latestChapter: string;
  views?: number;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ComicCard({
  id,
  title,
  author,
  category,
  cover,
  rating,
  status,
  latestChapter,
  views,
  variant = 'default',
}: ComicCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to="/category/all"
        className="group block w-[180px] flex-shrink-0 cursor-pointer"
      >
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
          <img
            src={cover}
            alt={title}
            title={`${title} - 韩漫免费网站`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-label whitespace-nowrap">
            {rating}
          </span>
        </div>
        <h3 className="text-sm font-heading font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1">{latestChapter}</p>
      </Link>
    );
  }

  return (
    <Link
      to="/category/all"
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-4">
        <img
          src={cover}
          alt={title}
          title={`${title} - 韩漫免费网站`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <p className="text-background-50 text-sm font-label whitespace-nowrap">
            立即阅读 →
          </p>
        </div>
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-md font-label whitespace-nowrap">
            {rating}
          </span>
          <span className="bg-background-50/90 text-foreground-800 text-xs px-2.5 py-1 rounded-md font-label whitespace-nowrap">
            {status}
          </span>
        </div>
      </div>
      <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
        {title}
      </h3>
      <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
        <span>{author}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-300" />
        <span className="text-primary-500">{category}</span>
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-foreground-600">{latestChapter}</span>
        {views && (
          <span className="text-xs text-foreground-400">
            {views > 10000 ? `${(views / 10000).toFixed(0)}万阅读` : `${views}阅读`}
          </span>
        )}
      </div>
    </Link>
  );
}